window.Products.Clothing.FlareDress = function() {
};
window.Products.Clothing.FlareDress.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.FlareDress.id = 36;
window.Products.Clothing.FlareDress.slug = 'flare-dress';
window.Products.Clothing.FlareDress.has_3d = true;
window.Products.Clothing.FlareDress.dpi = 150;

window.Products.Clothing.FlareDress.prototype.set3dProperties = function(modelViewer) {
    this.updateThreeTexture(modelViewer);
    modelViewer.object.position.y = -0.07;
    modelViewer.camera.position.z = 2.57;
    modelViewer.initalCameraPosition.z = -2.57;
};

window.Products.Clothing.FlareDress.prototype.setThreeControls = function(controls) {
    controls.minDistance = 2.3;
    controls.maxDistance = 2.9;
};

window.Products.Clothing.FlareDress.prototype.updateThreeTexture = function(modelViewer) {
    modelViewer.object.children[0].material.map = modelViewer.texture;
    modelViewer.object.children[1].material.map = modelViewer.texture;
    modelViewer.object.children[0].material.bumpScale = 0.0005;
    modelViewer.object.children[1].material.bumpScale = 0.0005;
};